module.exports = {
	"inports": {
		"json": {
			"process": "SendString",
			"port": "string"
		},
		"in": {
			"process": "SendString",
			"port": "in"
		}
	},
	"outports": {
		"out": {
			"process": "ParseJson",
			"port": "out"
		},
		"error": {
			"process": "ParseJson",
			"port": "error"
		}
	},
	"groups": [],
	"processes": {
		"SendString": {
			"component": "strings/SendString"
		},
		"ParseJson": {
			"component": "strings/ParseJson"
		}
	},
	"connections": [
		{
			"src": {
				"process": "SendString",
				"port": "out"
			},
			"tgt": {
				"process": "ParseJson",
				"port": "in"
			}
		}
	],
	"properties": {
		"description": "Send the parsed JSON when receiving a packet"
	},
	"caseSensitive": false
};